interface ConditionalInputConfig {
	key?: string;
	name: string;
	substrings: string[];
	type: 'selection' | 'input';
	values?: Record<string, string>; // only for selection
	validators?: { type: 'integer'; min: number; max: number }; // only for input
	defaultValue: string | number;
	tooltip: string;
}

export class AppConstant{
	public static BROKER_REQUEST_STATUS = {
        1:"Draft",
		2:"InitialRequest",
		3:"IndicativeQuote",
		4:"FirmQuote",
		5:"Bind",
		6: "QuoteRequested",
		8: "Cancelled",
		10:"Expired",
		11:"withUnderWriting"
	}
	public static BROKER_REQUEST_STATUS_V2 = {
		"Draft" : 1,
		"InitialRequest" : 2,
		"IndicativeQuote" : 3,
		"FirmQuote" : 4,
		"Bind" : 5,
		"QuoteRequested" : 6,
		"Cancelled" : 8,
		"Expired" : 10,
		"withUnderWriting":11
	}
	public static BROKER_QUOTE_STATUS = {
        1:"QuoteRequested",
		2:"Quote",
		3:"Bind",
		4:"withUnderWriting"
	}
	public static BROKER_QUOTE_STATUS_V2 = {
		"QuoteRequested" : 1,
		"Quote" : 2,
		"Bind" : 3,
		"withUnderWriting": 4
	}
	public static INSURABLE_INTEREST_STATUS = {
		"Created" : 1,
		"PremiumFinalised" : 2,
		"CapacityReserved" : 3,
		"UnderWriting" : 4,
	}

	public static conditionalInputs: ConditionalInputConfig[] = [
		{
			key: 'radius',
			name: 'radius',
			substrings: ['reask', 'cat', 'in', 'circle'],
			type: 'selection',
			values: {
				'30': '30', '35': '35', '40': '40', '45': '45', '50': '50', '55': '55',
				'60': '60', '65': '65', '70': '70', '75': '75', '80': '80'
			},
			defaultValue: '80',
			tooltip: 'Radius'
		},
		{
			key: 'terrain_correction',
			name: 'terrain_correction',
			substrings: ['reask', 'wind', 'location'],
			type: 'selection',
			values: {
				'full_terrain_gust': 'Full Terrain Gust',
				'open_water': 'Open Water',
				'open_terrain': 'Open Terrain',
				'all_open_terrain': 'All Open Terrain'
			},
			defaultValue: 'open_water',
			tooltip: 'Terrain Correction'
		},
		{
			key: 'wind_speed_averaging_period',
			name: 'wind_speed_averaging_period',
			substrings: ['reask', 'wind', 'location'],
			type: 'selection',
			values: { '10_minute': '10 Minutes', '1_minute': '1 Minute', '3_seconds': '3 Seconds' },
			defaultValue: '1_minute',
			tooltip: 'Wind Speed Averaging Period'
		},
		{
			key: 'radius',
			name: 'radius',
			substrings: ['usgs', 'magnitude', 'in', 'circle'],
			type: 'input',
			validators: { type: 'integer', min: 10, max: 100 },
			defaultValue: 50,
			tooltip: 'Radius'
		},
		{
			key: 'maximumDepth',
			name: 'maximumDepth',
			substrings: ['usgs', 'magnitude', 'in', 'circle'],
			type: 'input',
			validators: { type: 'integer', min: 10, max: 100 },
			defaultValue: 50,
			tooltip: 'Maximum Depth'
		},
		{
			key: 'maximumDepth',
			name: 'maximumDepth',
			substrings: ['usgs', 'magnitude', 'in', 'polygon'],
			type: 'input',
			validators: { type: 'integer', min: 10, max: 100 },
			defaultValue: 50,
			tooltip: 'Maximum Depth'
		},
		{
			key: 'maximumDepth',
			name: 'maximumDepth',
			substrings: ["usgs","peak","ground","acceleration"],
			type: 'input',
			validators: { type: 'integer', min: 10, max: 100 },
			defaultValue: 50,
			tooltip: 'Maximum Depth'
		},
		{
			key: 'radius',
			name: 'radius',
			substrings:  ["usgs","peak","ground","acceleration"],
			type: 'input',
			validators: { type: 'integer', min: 10, max: 100 },
			defaultValue: 50,
			tooltip: 'Radius'
		},
		{
			key: 'maximumDepth',
			name: 'maximumDepth',
			substrings: ["usgs","peak","ground","velocity"],
			type: 'input',
			validators: { type: 'integer', min: 10, max: 100 },
			defaultValue: 50,
			tooltip: 'Maximum Depth'
		},
		{
			key: 'radius',
			name: 'radius',
			substrings: ["usgs","peak","ground","velocity"],
			type: 'input',
			validators: { type: 'integer', min: 10, max: 100 },
			defaultValue: 50,
			tooltip: 'Radius'
		},
	];

	public static STATE_COUNTRIES = ["us", "au", "ca"];
	public static DISTRICT_COUNTRIES = ["us"];

}